import { createRoute, Outlet } from "@tanstack/react-router";
import { OnboardingCreateOrgScreen } from "@/app/Onboarding/Screens/OnboardingCreateOrgScreen";
import { OnboardingCreateSupplierScreen } from "@/app/Onboarding/Screens/OnboardingCreateSupplierScreen";
import { OnboardingWelcomeScreen } from "@/app/Onboarding/Screens/OnboardingWelcomeScreen";
import {
  hasOrgsLayout,
  noOrgLoggedInLayout,
  noOrgsLayout,
} from "@/app/Auth/Routes/loginRoutes";

export const onboardingRoute = createRoute({
  getParentRoute: () => noOrgsLayout,
  path: "/onboarding",
  component: Outlet,
  head: () => ({
    meta: [
      {
        title: "Onboarding - Imoova Admin",
      },
    ],
  }),
});

export const onboardingCreateOrJoinRoute = createRoute({
  getParentRoute: () => onboardingRoute,
  path: "/",
  component: OnboardingWelcomeScreen,
  head: () => ({
    meta: [
      {
        title: "Onboarding - Imoova Admin",
      },
    ],
  }),
});

export const onboardingCreateOrgRoute = createRoute({
  getParentRoute: () => noOrgLoggedInLayout,
  path: "/onboarding/create-org",
  component: OnboardingCreateOrgScreen,
  head: () => ({
    meta: [
      {
        title: "Create Organisation - Imoova Admin",
      },
    ],
    scripts: [
      {
        src: `https://www.google.com/recaptcha/enterprise.js?render=${import.meta.env.VITE_RECAPTCHA_SITE_KEY}`,
        async: true,
      },
    ],
  }),
});

export const onboardingCreateSupplierRoute = createRoute({
  getParentRoute: () => hasOrgsLayout,
  // Scoped to the org we're adding the supplier to — the org rides in the path
  // so the URL stays the single source of truth and `useOrgId` reads it like any
  // other scoped route. A sibling of the supplier layout rather than a child:
  // that route's optional `{-$supplierId}` segment would otherwise capture this.
  path: "/org/$orgId/create-supplier",
  component: OnboardingCreateSupplierScreen,
  head: () => ({
    meta: [
      {
        title: "Create Supplier - Imoova Admin",
      },
    ],
  }),
});
